import styled from 'styled-components';

export default styled.button`
    display: block;
    padding: 10px 15px;
    margin: 0 auto;
    border: none;
    border-radius: 0.078rem;

    text-decoration: none;
    cursor: pointer;
    font-size: 16px;
    background-color: #19a689;
    color: white;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    &:hover:enabled {
        opacity: 0.8;
    }
`;
